module.exports = __webpack_public_path__ + "img/my_qrcode_lingying_us.4291833.png";